export const consultsRoutes = {
  'route.consults.dialogue-box': '/users/[slug]/consult',
  'api.consults.create': 'consults/[hashed_user_id]/data/create',
  'api.consults.dialogue-box': 'consults/[hashed_user_id]/dialogue-box',
  'api.consults.dialogue-box-create': 'consults/[hashed_user_id]/dialogue-box/create',
  'api.consults.dialogue-box-store': 'consults/[hashed_user_id]/dialogue-box',
  'api.consults.datatable': 'consults/[hashed_user_id]/dialogue-box/datatable',
  'api.consults.check-open-data': 'consults/data/check-open-data',
  'api.consults.consult-store': 'consults/[hashed_user_id]/data',
  'api.consults.upload-file': 'upload/[sectionType].[sectionTypeDate]/[year]/[month]/[day]/[time]/[type]/file',
  'api.consults.electronic-prescription': 'consults/electronic-prescription-inquiry/[id]',
  'api.consults.online-tracking': 'consults/online-tracking/[id]',
};
